export const setUserPlan = (value: any) => {
	return {
		type: 'SET_USER_PLAN',
		payload: value,
	};
};
